import { validateForm, validateElement, invalidListener } from '@project/components/clientSideValidation';
import formValidation from '@assets/components/formValidation';

export default class BackInStock {
    init() {
        this.showModal();
        this.onSubmit();
        this.onModalHide();
    }

    showModal() {
        $('body').on('click', '.back-in-stock-btn', function (e) {
            e.preventDefault();
            $('.modal-body').spinner().start();
            $.ajax({
                url: $(this).data('action-url'),
                method: 'GET',
                dataType: 'json',
                success(data) {
                    $('body').append($(data.renderedTemplate));
                    const $modal = $('#bis-insert-email-modal');
                    $modal.find('form input:required, form select:required, form textarea:required').on('blur', validateElement);
                    invalidListener('#bis-insert-email-modal form input');
                    $modal.modal('show');
                },
                error(error) {
                    console.error(error);
                },
                complete() {
                    $.spinner().stop();
                },
            });
        });
    }

    onModalHide() {
        $('#bis-insert-email-modal').on('hidden.bs.modal', () => {
            $('#bis-insert-email-modal').remove();
        });
    }

    onSubmit() {
        $('body').on('submit', '#bis-form', function (e) {
            e.preventDefault();
            validateForm.call(this, e);
            const form = $(this);
            const url = form.attr('action');
            const data = form.serialize();
            $.ajax({
                url,
                method: 'POST',
                data,
                beforeSend: form.spinner().start(),
                success(response) {
                    form.spinner().stop();
                    if (!response.success) {
                        formValidation(form, response);
                    } else {
                        $('#bis-insert-email-modal').modal('hide');
                    }
                },
                error(error) {
                    form.spinner().stop();
                    $('#bis-insert-email-modal').modal('hide');
                    console.error(error);
                },
            });
        });
    }
}
